const project = {
  slug: "wildlife-threats-monitoring",
  title: "Wildlife Threats Monitoring (UAV + IoT + AI)",
  oneLiner: "UAV vision (YOLOv5) + IoT sensors + real-time dashboard for early alerts.",
  role: ["Research Lead (Group)"],
  category: "AI/ML",
  clientOrOrg: "Uva Wellassa University - Final Year Project",
  timeframe: { start: "2024-10", end: "2025-08", status: "Archived" },
  domain: ["AI", "Computer Vision", "Conservation", "IoT"],
  tech: ["YOLOv5", "Python", "GCP", "Firestore", "Cloud Storage", "Raspberry Pi", "Flutter/React"],
  links: { live: "https://wildasia.hirun.lk" },
  impact: [
    "Integrated drone video with sensor fusion to raise proactive alerts.",
    "Pilot tests showed robust detection for poaching, deforestation, bushfires."
  ],
  responsibilities: [
    "System design, model integration, dashboard UX, cloud pipelines"
  ],
  features: [
    "Real-time detections and snapshots",
    "Alerting to dashboard & mobile",
    "Zone configuration and playback"
  ],
  architecture: [
    "UAV RTMP stream → detection service (YOLOv5/TFLite)",
    "Sensor hub (temperature, smoke, acoustic) → Firestore",
    "React/Flutter dashboards + GCS snapshots"
  ],
  seo: {
    title: "Wildlife Threats Monitoring - AI Drone & IoT Case Study",
    description:
      "Designed an AI-enhanced drone and IoT system for early wildlife-threat alerts with YOLOv5, Raspberry Pi, and GCP."
  },
  cover: "/assets/wildasia/Wildlife-Threats-Monitoring-featured.png"
};

export default project;
